import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

import { Row } from '@simplywallst/ui-core';
import { sectionHeading } from '../../styled';

export const LocationContainerRow = styled(Row)`
  width: 100%;
`;

export const LocationHeader = styled.div`
  margin: ${({ theme }) => theme.x4spacePx}px
    ${({ theme }) => theme.x2spacePx}px 0;
  ${media.lgUp`
    margin: ${({ theme }) => theme.x7spacePx}px;
  `}
  text-align: center;
  h2 {
    ${sectionHeading}
  }
  p {
    ${({ theme }) => theme.typography.large};
    color: ${({ theme }) => theme.color.spaceGray};
  }
`;

export const LocationContentRow = styled(Row)`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.color.spaceGray};
  margin: ${({ theme }) => theme.x4spacePx}px
    ${({ theme }) => theme.x2spacePx}px;
  ${media.lgUp`
    margin: ${({ theme }) => theme.x7spacePx}px ${({ theme }) =>
      theme.x20spacePx}px ${({ theme }) => theme.x4spacePx}px;
  `}
`;

export const StyledReactMarkdown = styled('div')`
  color: ${({ theme }) => theme.color.spaceGray};
  ${media.mdUp`
    margin-left: ${({ theme }) => theme.x4spacePx}px;
  `}
  h4 {
    color: ${({ theme }) => theme.color.spaceGray};
    font-weight: 700;
    font-size: 24px;
    letter-spacing: -0.02em;
  }
  p {
    ${({ theme }) => theme.typography.large};
    color: ${({ theme }) => theme.color.spaceGray};
    font-size: 18px;
    width: 80%;
    ${media.lgUp`
      width: 70%;
    `}
  }
`;

export const MapContainer = styled.iframe`
  border: 0;
  ${media.smDown`
    width: 100%;
  `}
`;
